// extracted by mini-css-extract-plugin
export default {"accept-drop":"_18iGJ","acceptDrop":"_18iGJ","reject-drop":"_1MCTh","rejectDrop":"_1MCTh"};